import { Button } from "@/components/ui/button";
import { Settings2 } from "lucide-react";

/**
 * The exact settings button, rendered inert and invisible.
 *
 * Home has no workspace settings, and the private workspace has nothing to
 * edit/share/archive — but both must reserve the control's box so the clock
 * beside it never moves. An empty spacer isn't enough: the header row is
 * `items-baseline`, and a box with no text contributes no baseline, which
 * shifts the clock vertically by a pixel or two. Rendering the real button
 * keeps the metrics identical.
 *
 * `invisible` (visibility: hidden) also takes it out of the tab order and hit
 * testing, so there is nothing to click and nothing for a screen reader.
 */
export function HeaderSettingsSlot() {
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      aria-hidden
      tabIndex={-1}
      disabled
      className="invisible"
    >
      <Settings2 />
    </Button>
  );
}
